export const testimonials = [
  {
    imgSrc: "/assets/images/testimonial/testimonial-01.jpg",
    alt: "Corporate Template",
    description:
      "“ Excepteur sint occaecat cupidatat non proident mollit anim..„",
    title: "Sr Janen Sara",
    subtitle: "Sr Product Designer",
    salDelay: 0,
  },
  {
    imgSrc: "/assets/images/testimonial/testimonial-02.jpg",
    alt: "Corporate React Template",
    description:
      "“Duis aute irure dolor in reprehenderit cillum dolore eu fugiat nulla pariatur.„",
    title: "Afsana Nila",
    subtitle: "App Developer",
    salDelay: 100,
  },
  {
    imgSrc: "/assets/images/testimonial/testimonial-03.jpg",
    alt: "Corporate React Template",
    description:
      "“Proin libero vel lorem dui lupus est aliquet luctus purus justo eget libero sed lorem.„",
    title: "Afanan Sifa",
    subtitle: "Accounts Manager",
    salDelay: 200,
  },
];

export const testimonials2 = [
  {
    imgSrc: "/assets/images/testimonial/testimonial-01.jpg",
    alt: "Corporate Template",
    description:
      "“Proin libero vel lorem dui lupus est aliquet luctus purus justo eget libero sed lorem.„",
    title: "Janen Sara",
    subtitle: "Sr Product Designer",
    salDelay: 0,
  },
  {
    imgSrc: "/assets/images/testimonial/testimonial-02.jpg",
    alt: "Corporate React Template",
    description:
      "“Proin libero vel lorem dui lupus est aliquet luctus purus justo eget libero sed lorem.„",
    title: "Afsana Nila",
    subtitle: "App Developer",
    salDelay: 100,
  },
  {
    imgSrc: "/assets/images/testimonial/testimonial-03.jpg",
    alt: "Corporate React Template",
    description:
      "“Proin libero vel lorem dui lupus est aliquet luctus purus justo eget libero sed lorem.„",
    title: "Hasina",
    subtitle: "Accounts Manager",
    salDelay: 200,
  },
  {
    imgSrc: "/assets/images/team/team-01.jpg",
    alt: "Corporate React Template",
    description:
      "“Proin libero vel lorem dui lupus est aliquet luctus purus justo eget libero sed lorem.„",
    title: "Lamia Aktar",
    subtitle: "Accounts Manager",
    salDelay: 200,
  },
  {
    imgSrc: "/assets/images/team/team-02.jpg",
    alt: "Corporate React Template",
    description:
      "“Proin libero vel lorem dui lupus est aliquet luctus purus justo eget libero sed lorem.„",
    title: "Nora Fati",
    subtitle: "Accounts Manager",
    salDelay: 200,
  },
  {
    imgSrc: "/assets/images/team/team-03.jpg",
    alt: "Corporate React Template",
    description:
      "“Proin libero vel lorem dui lupus est aliquet luctus purus justo eget libero sed lorem.„",
    title: "Aklima Ket",
    subtitle: "Accounts Manager",
    salDelay: 200,
  },
];

export const testimonials3 = [
  {
    location: "USA",
    description:
      "What I am primarily looking for with new projects is a fit on both a visual and aesthetic level as well as on a personal level with the client.",
    clientName: "Darun Due",
    clientRole: "Web Developer",
    imgSrc: "/assets/images/testimonial/testimonial-dark-01.jpg",
    imgAlt: "Corporate Template",
    imgWidth: 918,
    imgHeight: 928,
  },
  {
    location: "INDIA",
    description:
      "What I am primarily looking for with new projects is a fit on both a visual and aesthetic level as well as on a personal level with the client.",
    clientName: "Mohima Ale",
    clientRole: "App Developer",
    imgSrc: "/assets/images/testimonial/testimonial-dark-02.jpg",
    imgAlt: "Corporate Template",
    imgWidth: 920,
    imgHeight: 920,
  },
  {
    location: "Bangladesh",
    description:
      "What I am primarily looking for with new projects is a fit on both a visual and aesthetic level as well as on a personal level with the client.",
    clientName: "John Roni",
    clientRole: "App Developer",
    imgSrc: "/assets/images/testimonial/testimonial-dark-03.jpg",
    imgAlt: "Corporate Template",
    imgWidth: 920,
    imgHeight: 920,
  },
];
